import React, {useEffect, useState} from 'react';
import Lottie from 'react-lottie-player';
import {detectBaseUrl, isIOSDevice} from "../VoiceSearch";

const LoadingSpinner = ({
                            size = "300",
                            className = "",
                            containerClassName = "",
                            centered = true
                        }) => {

    const [isIOS, setIsIOS] = useState(false);

    const [baseUrl, setBaseUrl] = useState(detectBaseUrl());

    useEffect(() => {
        setIsIOS(isIOSDevice());
        setBaseUrl(detectBaseUrl());
    }, []);

    const sizeClasses = {
        "100": "w-24",
        "150": "w-36",
        "200": "w-48",
        "300": "w-72",
        "400": "w-96"
    };

    const positionClasses = centered
        ? "absolute inset-0 flex items-center justify-center"
        : "absolute";

    if (isIOS) {
        return (
            <div className={`${positionClasses} z-50 pointer-events-none ${containerClassName}`}>
            <span className={`inline-flex items-center justify-center ${sizeClasses[size]} ${className}`}>
                <Lottie
                    path={`${baseUrl}/animations/xyPo0jt3EE.json`}
                    loop
                    play
                    style={{ width: '100%', height: '100%' }}
                    rendererSettings={{ preserveAspectRatio: 'xMidYMid meet' }}
                />
            </span>
            </div>
        )
    }
    else {
        return (
            <div className={`${positionClasses} z-50 pointer-events-none ${containerClassName}`}>
            <span className={`inline-flex items-center justify-center ${sizeClasses[size]} ${className}`}>
                <Lottie
                    path={`${baseUrl}/animations/xyPo0jt3EE.json`}
                    loop
                    play
                    style={{ width: '100%', height: '100%' }}
                    rendererSettings={{ preserveAspectRatio: 'xMidYMid meet' }}
                />
            </span>
            </div>
        );
    }
};

export default LoadingSpinner;
